import { CommonModule, Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterModule, ActivatedRoute } from '@angular/router';
import { UserStoreProvider } from 'projects/shared/providers/user.provider';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { ProfileService } from '../../panel/setting/services/profile.service';
import { StaffLoginResponse } from 'projects/shared/models/interfaces/staff';
import { SkeletonModule } from 'primeng/skeleton';
import { OrderService } from 'projects/shared/services/order.service';
import { WalletService } from 'projects/shared/services/wallet.service';
import { TicketSystemService } from 'projects/shared/services/ticket-system.service';
import { BehaviorSubject, distinctUntilChanged, filter, noop, tap } from 'rxjs';
import { SideMenuService } from './services/side-menu.service';
import { OrdersSocketService } from '../../panel/orders/services/orders-socket.service';
import { ToastService } from '../../../shared/helpers/toast.service';
import { AdminTicketSocketService } from 'projects/shared/services/ticket-admin-socket.service';

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, SkeletonModule],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss'
})
export class SideMenuComponent implements OnInit {
  mainSideItems!: ISideItems[];
  settingSideItems!: ISideItems[];
  user!: StaffLoginResponse;
  countTopups!: number;
  ordersCounts!: number;
  ticketsCounts!: any;
  darkMode = true;
  sideMenuInitialized = false;

  checkCounts = new BehaviorSubject<({ orders?: boolean, tickets?: boolean, topUp?: boolean })>({ orders: false, tickets: false, topUp: false })
  expand = true;
  notallowCoustoumEmail = false;

  categoryRoutesActivation = {
    mainCategory: false,
    category: false,
    subCategory: false
  }

  mainExpanders: any = {
    categories: location.pathname.includes('categories'),
    users: location.pathname.split('/')[2] == 'users',
    products: location.pathname.split('/')[2] == 'products',
    wallets: location.pathname.split('/')[2] == 'wallets',
    orders: location.pathname.split('/')[2] == 'orders',
    licenses: location.pathname.split('/')[2] == 'licenses',
    tickets: ['contactUs', 'tickets'].includes(location.pathname.split('/')[2]),
    payments: location.pathname.split('/')[2] == 'payments',
    messages: ['message', 'notifications'].includes(location.pathname.split('/')[2]),
    legal: location.pathname.split('/')[1] == 'legal',
    webSetting: ['web-setting', 'social-media', 'mintanance'].includes(location.pathname.split('/')[2])
  }


  constructor(
    private userStore: UserStoreProvider,
    private router: Router,
    private storeChanges: StoreChangesService,
    private profileService: ProfileService,
    private orderServ: OrderService,
    private ticketSystemService: TicketSystemService,
    private walletServ: WalletService,
    private sideMenuService: SideMenuService,
    private storeChangesServ: StoreChangesService,
    private toastService: ToastService,
    private ordersSocketService: OrdersSocketService,
    private ticketSocketService: AdminTicketSocketService,
  ) { }

  ngOnInit(): void {
    this.checkMode();

    this.orderServ.getCountOrders();
    this.getOrderCounts();

    this.walletServ.getCountTopUps();
    this.getCountTopups();

    this.ticketSystemService.getCountByStatus();
    this.getTicketsCounts();

    this.changeRouteListener();

    this.listenOrderCountsFromSocket();

    this.listenTicketCountsFromSocket();

    this.validateUserData();

    this.watchRoute(location.pathname)

  }

  validateUserData() {
    this.storeChangesServ.getUserAdmin().subscribe(
      res => {
        this.user = res
        if (res) {
          this.user = res;
          if (this.user.email == 'card4games2000+1@gmail.com') {
            // if (this.user.email == 'mohamed01002630753@gmail.com') {
            this.notallowCoustoumEmail = true;
          }
        }
      }
    )
  }

  listenOrderCountsFromSocket() {
    this.ordersSocketService.newOrder.pipe(
      distinctUntilChanged(),
      tap(
        res => {
          if (res.status?.toLowerCase() == 'processing') {
            this.ordersCounts++
          }
          if (res?._id) this.toastService.toastData.next({ severity: 'info', detail: 'There is new order', summary: 'Info' })
        }
      )
    ).subscribe(noop);
  }

  listenTicketCountsFromSocket() {
    this.ticketSocketService.adminNewTicket.pipe(
      distinctUntilChanged(),
      tap(
        ticket => {
          if (ticket) {
            if (ticket.status == 'Open') {
              this.ticketsCounts++;
            }
          }
          if (ticket?._id) this.toastService.toastData.next({ severity: 'info', detail: 'There is new ticket', summary: 'Info' })

        }
      )
    ).subscribe(noop);

  }


  changeRouteListener() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        // Navigation started
        let locationPath = event.url;
        this.watchRoute(locationPath);
        setTimeout(() => {
          this.changeExpanders();

        }, 100);
      }
    });
  }

  changeExpanders() {
    let path = location.pathname.split('/')[2]
    Object.keys(this.mainExpanders)?.map(key => {

      if (!path?.includes('categories')) {
        if (key?.toLowerCase() == path?.toLowerCase()) {

          this.mainExpanders[key] = true;
        } else if (['web-setting', 'social-media', 'mintanance'].includes(path)) {
          this.mainExpanders['web-setting'] = true;
        } else if (['message', 'notifications'].includes(path)) {
          this.mainExpanders['messages'] = true;
        }
      } else {
        if (key.toLowerCase() == 'categories') this.mainExpanders[key] = true;
        else this.mainExpanders[key] = false;
      }
    })
  }

  // ! this funcs for route activation of categories

  checkAnyRouteActiveNow(path: string) {
    if (path.includes('mainCategories')) {
      this.activeMainCategories();
    } else if (path.includes('categories')) {
      this.activeCategories();
    } else if (path.includes('subCategory')) {
      this.activeSubCategories();
    }
  }

  activeMainCategories() {
    this.categoryRoutesActivation.mainCategory = true;
    this.categoryRoutesActivation.category = false;
    this.categoryRoutesActivation.subCategory = false;
  }

  activeCategories() {
    this.categoryRoutesActivation.mainCategory = false;
    this.categoryRoutesActivation.category = true;
    this.categoryRoutesActivation.subCategory = false;
  }

  activeSubCategories() {
    this.categoryRoutesActivation.mainCategory = false;
    this.categoryRoutesActivation.category = false;
    this.categoryRoutesActivation.subCategory = true;
  }

  // ! ================================================




  getCountTopups() {
    this.sideMenuService.topUpsCount_BS.pipe(
      filter(count => !!count),
      tap(
        res => {
          this.countTopups = res?.Processing
        }
      )).subscribe(noop,)
  }

  getOrderCounts() {
    this.sideMenuService.orderCount_BS.pipe(
      filter(count => !!count),
      tap(
      res => {
        res?.map(
          (ele: any) => {
            if (ele._id?.toLowerCase() == 'processing') {
              this.ordersCounts = ele.count
            }
          }

        )
        this.ordersCounts
      }
    )).subscribe(noop,)
  }

  getTicketsCounts() {
    this.sideMenuService.ticketCount_BS.pipe(tap(
      res => {
        this.ticketsCounts = res;
      }
    )).subscribe(noop,)
  }

  collapseSiblings(label: string) {
    Object.keys(this.mainExpanders)?.map(key => {
      if (label.toLowerCase() != key.toLowerCase()) {
        this.mainExpanders[key] = false
      } else if (label == '') {
        this.mainExpanders[key] = false;
      }
    })
  }


  watchRoute(locationPath: string) {
    // ! ====   For Categories  =======

    if (locationPath.toLowerCase().includes('categories')) {
      if (locationPath.includes('route')) {

        let path = locationPath.split(';')[1];
        this.checkAnyRouteActiveNow(path);
      } else {
        let path = locationPath.split('/')[locationPath.includes('subCategory') ? 4 : 3];
        this.checkAnyRouteActiveNow(path);
      }
    }
    // ! =========================================================================
  }

  logout() {
    this.userStore.logout$().subscribe((res) => {
      localStorage.removeItem('userRole');
      localStorage.removeItem('isLoggedIn');
      this.router.navigateByUrl('/auth/login');
      this.storeChanges.setUser({});
    });
  }

  getUserData() {
    this.profileService.userData.subscribe(
      res => {
        if (res) {
          this.user = res;
          if (this.user.email == 'card4games2000+1@gmail.com') {
            // if (this.user.email == 'mohamed01002630753@gmail.com@gmail.com') {
            this.notallowCoustoumEmail = true;
          }
        }
      }
    )
  }

  checkMode() {
    this.darkMode = localStorage.getItem('dark') == 'true' ? true : false;
  }

  @HostListener('window:storage', ['$event'])
  storageListener(event: StorageEvent) {
    let { key, oldValue } = event;
    if (key == 'dark') localStorage.setItem(key!, oldValue!)
  }

  setKeyForMode() {
    this.sideMenuService.darkMode.next(this.darkMode ? true : false);
    localStorage.setItem('dark', this.darkMode ? 'true' : 'false');
  }

}


interface ISideItems {
  icon?: string;
  label: string;
  route?: { route: string };
  path?: string;
  class?: string;
  class2?: string;
  class3?: string;
  dropdown?: boolean;
  expanded?: boolean;
  subMenu?: ISideItems[];
  logout?: any;
  active?: boolean;
  key?: boolean
  disabled?: boolean
  event?: { have?: boolean, value?: number }
}
